export const fields = [
  { label: 'Nama Template', key: 'name', isSortable: true, isRedirectable: true },
  { label: 'Deskripsi', key: 'description', isSortable: true },
  { label: 'Dibuat Oleh', key: 'created_by', isSortable: true },
  { label: 'Tanggal Dibuat', key: 'created_on', isSortable: true },
  { label: 'Diubah Oleh', key: 'updated_by', isSortable: true },
  { label: 'Tanggal Diubah', key: 'updated_on', isSortable: true },
]